import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CreateRegionCountryMasterPage = withSuspense(lazy(() => import('./region-country-master-page')));
export default CreateRegionCountryMasterPage;
